// «Capas ▾»: qué se ve en el mapa, qué estados de las paradas y si se agrupan
// los puntos al alejar el zoom. Se cierra al tocar afuera.
import React, { useEffect, useRef } from "react";
import Button from "../ui/Button";
import { LayerKey, LayerPrefs, LAYERS, STATE_COLOR, STATE_LABEL, StopState } from "../../lib/mapLayers";
import { capaStyle, menuStyle, punto, smallMutedStyle } from "./styles";

type Props = {
  capas: typeof LAYERS;
  prefs: LayerPrefs;
  // Cuántos hay de cada capa («2/40» si un filtro deja ver menos).
  conteo: Partial<Record<LayerKey, number | string>>;
  // Paradas de hoy por estado (colectas + repartos).
  porEstado: Record<StopState, number>;
  abierto: boolean;
  onAbierto: (abierto: boolean) => void;
  onCapa: (k: LayerKey) => void;
  onEstado: (s: StopState) => void;
  onAgrupar: () => void;
};

export default function LayersMenu({ capas, prefs, conteo, porEstado, abierto, onAbierto, onCapa, onEstado, onAgrupar }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!abierto) return;
    const fuera = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) onAbierto(false); };
    document.addEventListener("mousedown", fuera);
    return () => document.removeEventListener("mousedown", fuera);
  }, [abierto, onAbierto]);

  const prendidas = capas.filter((c) => prefs.visible[c.key]).length;
  return (
    <div ref={ref} style={{ position: "relative" }}>
      <Button variant="secondary" onClick={() => onAbierto(!abierto)} style={{ minHeight: "38px", padding: "6px 12px", fontSize: "14px" }}>
        Capas ▾ <span style={{ ...smallMutedStyle, fontWeight: 400 }}>{prendidas} de {capas.length}</span>
      </Button>
      {abierto ? (
        <div role="group" aria-label="Capas del mapa" style={menuStyle}>
          {capas.map((c) => (
            <label key={c.key} style={capaStyle(prefs.visible[c.key])}>
              <input type="checkbox" checked={prefs.visible[c.key]} onChange={() => onCapa(c.key)} style={{ margin: 0 }} />
              <i style={{ ...punto(c.color), marginRight: 0 }} />
              <span style={{ flex: 1 }}>{c.label}</span>
              <span style={smallMutedStyle}>{conteo[c.key] ?? "…"}</span>
            </label>
          ))}
          <div role="group" aria-label="Estado de las paradas" style={{ ...smallMutedStyle, borderTop: "1px solid var(--border)", paddingTop: "8px", marginTop: "4px", display: "flex", flexDirection: "column", gap: "6px" }}>
            <span>Paradas de hoy en el mapa:</span>
            {(Object.keys(STATE_LABEL) as StopState[]).map((s) => (
              <label key={s} style={{ display: "inline-flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
                <input type="checkbox" checked={prefs.states[s]} onChange={() => onEstado(s)} style={{ margin: 0 }} />
                <i style={{ ...punto(STATE_COLOR[s]), marginRight: 0 }} />
                {STATE_LABEL[s]} ({porEstado[s]})
              </label>
            ))}
          </div>
          <label style={{ ...smallMutedStyle, borderTop: "1px solid var(--border)", paddingTop: "8px", display: "inline-flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
            <input type="checkbox" checked={prefs.cluster} onChange={onAgrupar} style={{ margin: 0 }} />
            Agrupar puntos cercanos al alejar el zoom
          </label>
        </div>
      ) : null}
    </div>
  );
}
